/** Normalize shift id(s) from API (string, number, or array) for checkbox state. */
export function parseWorkforceShiftIds(shift) {
  if (shift == null || shift === "") return [];

  if (Array.isArray(shift)) {
    return shift
      .map((id) => Number(id))
      .filter((n) => !Number.isNaN(n));
  }

  if (typeof shift === "number" && !Number.isNaN(shift)) {
    return [shift];
  }

  const shiftStr = String(shift).trim();
  if (shiftStr.startsWith("[") && shiftStr.endsWith("]")) {
    try {
      const parsed = JSON.parse(shiftStr);
      if (Array.isArray(parsed)) {
        return parsed
          .map((id) => Number(id))
          .filter((n) => !Number.isNaN(n));
      }
    } catch {
      // fall through to comma-separated parsing
    }
  }

  return shiftStr
    .split(",")
    .map((part) => Number(String(part).trim()))
    .filter((n) => !Number.isNaN(n));
}

export function isShiftSelected(selectedIds, shiftId) {
  const id = Number(shiftId);
  return selectedIds.some((selected) => Number(selected) === id);
}
